<!--begin::Container-->
<div [ngClass]="headerContainerCSSClasses" class="d-flex align-items-stretch justify-content-between">
  <ng-container *ngIf="loader$ | async as _loader">
    <ngb-progressbar class="loading-bar" height="3px" [value]="_loader"></ngb-progressbar>
  </ng-container>

  <ng-container *ngIf="headerMenuSelfDisplay">
    <!--begin::Header Menu Wrapper-->
    <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
      <ng-container *ngIf="asideSelfDisplay">
        <!--begin::Header Logo-->
        <div class="header-logo" style="display: inline-block;">
          <a [routerLink]="['/']" style="display: inline-block;">
            <img alt="Logo" [attr.src]="headerLogo"
              style="width: 60px; height: 60px; margin-top: -30px !important;" />
          </a>
          <div style="margin-left: 20px !important; margin-top: 7px !important; display: inline-block;">
            <h1 style="color: #96b4ff !important; margin-bottom: -0.5px !important;">
              {{appTitle}}
            </h1>

            <span style="color: #b4cdff !important; font-weight: 900 !important; margin-left: 1px !important;">
              {{appVersion}}
            </span>
          </div>
        </div>
        <!--end::Header Logo-->
      </ng-container>

        <!--begin::Header Menu-->
        <!-- Don't change id => 'kt_header_menu' -->
        <!--<ng-container *ngIf="headerMenuSelfStatic">-->
        <!-- STATIC MENU -->
        <!--<app-header-menu
          #ktHeaderMenu
          id="kt_header_menu"
          class="header-menu header-menu-mobile"
          [ngClass]="headerMenuCSSClasses"
        ></!->
      </ng-container>-->
        <!--end::Header Menu-->
    </div>
    <!--end::Header Menu Wrapper-->
  </ng-container>

  <ng-container *ngIf="!headerMenuSelfDisplay">
    <div></div>
  </ng-container>

  <app-topbar class="topbar" *ngIf="!isBrowsing"></app-topbar>
</div>
<!--end::Container-->